const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class CalendarBlockService {
  static getHeaders(token) {
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  static async getCalendarBlocks(doctorId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/calendar-blocks/doctor/${doctorId}`, {
        method: 'GET',
        headers: this.getHeaders(token)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data.data || [];
    } catch (error) {
      console.error('Error fetching calendar blocks:', error);
      throw error;
    }
  }

  static async getCalendarBlockOccurrences(doctorId, { startDate, endDate, timezone }, token) {
    try {
      const queryParams = new URLSearchParams({ startDate, endDate, timezone });
      const response = await fetch(`${API_BASE_URL}/calendar-blocks/doctor/${doctorId}/occurrences?${queryParams.toString()}`, {
        method: 'GET',
        headers: this.getHeaders(token)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data.data || [];
    } catch (error) {
      console.error('Error fetching calendar block occurrences:', error);
      throw error;
    }
  }

  // One request for every selected doctor instead of one per doctor (N+1).
  static async getCalendarBlockOccurrencesForDoctors(doctorIds, { startDate, endDate, timezone }, token) {
    try {
      const queryParams = new URLSearchParams({ doctorIds: doctorIds.join(','), startDate, endDate, timezone });
      const response = await fetch(`${API_BASE_URL}/calendar-blocks/occurrences?${queryParams.toString()}`, {
        method: 'GET',
        headers: this.getHeaders(token)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data.data || [];
    } catch (error) {
      console.error('Error fetching calendar block occurrences:', error);
      throw error;
    }
  }

  static async createCalendarBlock(blockData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/calendar-blocks`, {
        method: 'POST',
        headers: this.getHeaders(token),
        body: JSON.stringify(blockData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data.data;
    } catch (error) {
      console.error('Error creating calendar block:', error);
      throw error;
    }
  }

  static async updateCalendarBlock(id, blockData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/calendar-blocks/${id}`, {
        method: 'PUT',
        headers: this.getHeaders(token),
        body: JSON.stringify(blockData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data.data;
    } catch (error) {
      console.error('Error updating calendar block:', error);
      throw error;
    }
  }

  static async deleteCalendarBlock(id, payload, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/calendar-blocks/${id}`, {
        method: 'DELETE',
        headers: this.getHeaders(token),
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('Error deleting calendar block:', error);
      throw error;
    }
  }
}

export default CalendarBlockService;